<template>
  <div class="mobile_scene">
    <div id="Swip" ref="swiper" class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in applicationInfo"
          :key="index"
          class="swiper-slide"
        >
          <img :src="item.imgUrl" alt="" />
          <div class="swiper_text">
            <p style="margin-bottom: 11px; font-size: 20px; font-weight: 700;" class="swiper_text_pen">{{ item.title }}</p>
            <p style="font-size: 12px; font-weight: 300;" class="swiper_text_pen1">{{ item.msg }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  data() {
    return {
      // bannerList: [
      //   {
      //     url: require("@/asset/mobile/scene_banner/scene_banner.png"),
      //     title: "Stage Performance",
      //     msg: "In collaboration with hecoos' rehearsal interface, artists and engineers can work together to discuss and clearly define every detail of the plan. This ensures a solid and dependable foundation for the seamless execution and remarkable delivery of the performance.",
      //   },
      //   {
      //     url: require("@/asset/mobile/scene_banner/scene_banner.png"),
      //     title: "111111",
      //     msg: "In collaboration with hecoos' rehearsal interface, artists and engineers can work together to discuss and clearly define every detail of the plan. This ensures a solid and dependable foundation for the seamless execution and remarkable delivery of the performance.",
      //   },
      //   {
      //     url: require("@/asset/mobile/scene_banner/scene_banner.png"),
      //     title: "22222222",
      //     msg: "In collaboration with hecoos' rehearsal interface, artists and engineers can work together to discuss and clearly define every detail of the plan. This ensures a solid and dependable foundation for the seamless execution and remarkable delivery of the performance.",
      //   },
      // ],
    };
  },
  props: {
    applicationInfo: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    new Swiper(this.$refs.swiper, {
      autoplay: {
        delay: 2000,
        // 交互后保持自动播放
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        // 可点击
        clickable: true,
      },
      // 禁用滑动
      allowTouchMove: true,
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/en_mobile/mobile_xty.scss";
</style>